import React from 'react';
import IconVisa from './static/svg/visa_landingpage.png';
import IconMastercard from './static/svg/mastercard_landing.png';
import IconSwish from './static/svg/swish_landing.png';
import IconKlarna from './static/svg/klarna_landing.png';
import { Link as RouterLink } from 'react-router-dom';

const linkStyle = {
  color: 'rgba(255,255,255,0.5)',
  fontSize: 14,
  textDecoration: 'none',
  transition: 'color 0.15s',
  lineHeight: 1.8,
  display: 'block',
  background: 'none',
  border: 'none',
  padding: 0,
  cursor: 'pointer',
  fontFamily: 'inherit',
};

const BottomSection = ({ isMobileView, setOpenCookieBar, setCookieConsentGiven }) => {
  const handleHover = (e) => { e.currentTarget.style.color = '#fff'; };
  const handleLeave = (e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.5)'; };

  return (
    <footer style={{
      backgroundColor: '#161825',
      color: 'rgba(255,255,255,0.6)',
      padding: '64px 24px 40px',
    }}>
      <div style={{ maxWidth: 960, margin: '0 auto' }}>

        {/* Top section: brand + columns */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: '1.2fr 1fr 1fr 1fr',
          gap: 48,
          marginBottom: 48,
        }}>
          {/* Brand column */}
          <div>
            <div style={{
              fontSize: 22, fontWeight: 700, color: '#fff',
              letterSpacing: '-0.3px', marginBottom: 12,
            }}>
              PosterTopia
            </div>
            <p style={{
              fontSize: 13, color: 'rgba(255,255,255,0.4)',
              lineHeight: 1.7, margin: 0,
            }}>
              Unika posters och prints för ditt hem. Kvalitet och stil i varje detalj.
            </p>
          </div>

          {/* Om oss */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{
              color: '#fff', fontSize: 13, fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '1px',
              margin: '0 0 16px',
            }}>
              Om oss
            </h4>
            <RouterLink to="/1-om-oss" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Om oss</RouterLink>
            <RouterLink to="/1-posters" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Posters</RouterLink>
          </div>

          {/* Sociala media */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{
              color: '#fff', fontSize: 13, fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '1px',
              margin: '0 0 16px',
            }}>
              Sociala media
            </h4>
            <a href="https://www.instagram.com/postertopiase/" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Instagram</a>
            <a href="https://www.facebook.com/people/PosterTopia/100092724335980/" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Facebook</a>
            <a href="https://twitter.com/postertopia" target="_blank" rel="noopener noreferrer" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>X (Twitter)</a>
          </div>

          {/* Kundservice */}
          <div style={{ textAlign: 'center' }}>
            <h4 style={{
              color: '#fff', fontSize: 13, fontWeight: 700,
              textTransform: 'uppercase', letterSpacing: '1px',
              margin: '0 0 16px',
            }}>
              Kundservice
            </h4>
            <RouterLink to="/1-kontakta-oss" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Kontakta oss</RouterLink>
            <RouterLink to="/1-vanliga-fragor" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Vanliga frågor</RouterLink>
            <RouterLink to="/1-kopvillkor" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Köpvillkor</RouterLink>
            <RouterLink to="/1-leverans" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Leverans</RouterLink>
            <RouterLink to="/1-cookiepolicy" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Cookiepolicy</RouterLink>
            <RouterLink to="/1-integritetspolicy" style={linkStyle} onMouseOver={handleHover} onMouseOut={handleLeave}>Integritetspolicy</RouterLink>
            <button style={linkStyle} onClick={() => setCookieConsentGiven(false)} onMouseOver={handleHover} onMouseOut={handleLeave}>Hantera cookies</button>
          </div>
        </div>

        {/* Divider */}
        <div style={{
          height: 1,
          background: 'rgba(255,255,255,0.1)',
          marginBottom: 28,
        }} />

        {/* Bottom row */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}>
          <p style={{
            fontSize: 13, color: 'rgba(255,255,255,0.35)',
            margin: 0, fontWeight: 400,
          }}>
            &copy; 2026 PosterTopia AB. Alla rättigheter förbehållna.
          </p>
          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
            {[
              { src: IconVisa, alt: 'Visa' },
              { src: IconMastercard, alt: 'Mastercard' },
              { src: IconKlarna, alt: 'Klarna' },
              { src: IconSwish, alt: 'Swish' },
            ].map((icon, i) => (
              <img
                key={i}
                src={icon.src}
                alt={icon.alt}
                style={{
                  height: 24,
                  width: 'auto',
                  opacity: 0.5,
                  filter: 'grayscale(100%) brightness(2)',
                  transition: 'opacity 0.15s',
                }}
                onMouseOver={(e) => e.currentTarget.style.opacity = '0.9'}
                onMouseOut={(e) => e.currentTarget.style.opacity = '0.5'}
              />
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default BottomSection;
